module.exports = __webpack_public_path__ + "img/icon-checkmark.7bdd3143.svg";